import React, { useEffect, useState } from "react";
import { Grid, Box, Button, FormLabel, TextField, Typography } from "../../../components/ui";
import { toast } from "react-toastify";
import axiosInstance from "../../../axios/axiosInstance";
import { handeleUpdateStatus } from "../../../utils/update-request-status";

interface Prop {
  onClose: () => void;
  requestData?: any;
  requestId?: any;
  id?: any;
}
const CompanyForm: React.FC<Prop> = ({
  onClose,
  requestData,
  requestId,
  id,
}) => {
  const role: any = localStorage.getItem("role");
  const [formData, setFormData] = useState<any>();
  const handleChange = (key: any, value: any) => {
    setFormData({ ...formData, [key]: value });
  };
  console.log("fromdata", formData);

  const handleSubmit = () => {
    if (!formData.name) {
      toast.error("Name is required");
      return;
    }
    if (!formData.floor) {
      toast.error("Floor is required");
      return;
    }
    if (formData.id) {
      handleUpdate();
    } else {
      handleCreate();
    }
  };

  const handleCreate = async () => {
    try {
      // When approving a request, execute directly without invocation
      const url = requestId 
        ? `/api/company` 
        : `/api/company?invocation=${role}`;
      
      const response = await axiosInstance.post(url, formData);
      if (response.status === 200) {
        if (requestId) {
          handeleUpdateStatus(requestId, "1");
        }
        if (requestId) {
          toast.success("Request approved and company created successfully!");
        } else if (role == 0) {
          toast.success("Company created successfully!");
        } else {
          toast.success("Request sent successfully!");
        }
        onClose();
        setFormData({ name: "", floor: "" });
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.body || error?.message);
    }
  };

  const handleGetOne = async (id: any) => {
    try {
      const resp: any = await axiosInstance.get(`/api/company/${id}`);
      if (resp?.status === 200) {
        setFormData(resp?.data?.data);
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.body);
    }
  };

  const handleUpdate = async () => {
    console.log(formData);

    try {
      // When approving a request, execute directly without invocation
      const url = requestId 
        ? `/api/company/${formData?.id}` 
        : `/api/company/${formData?.id}?invocation=${role}`;
      
      const response = await axiosInstance.put(url, formData);
      if (response.status === 200) {
        if (requestId) {
          handeleUpdateStatus(requestId, "1");
        }
        if (requestId) {
          toast.success("Request approved and company updated successfully!");
        } else if (role == 0) {
          toast.success("Company Updated successfully!");
        } else {
          toast.success("Request sent successfully!");
        }
        onClose();
        setFormData({ name: "", floor: "" });
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.body || error?.message);
    }
  };

  useEffect(() => {
    if (requestData) {
      setFormData(requestData);
    }
  }, [requestData]);

  useEffect(() => {
    id && handleGetOne(id);
  }, [id]);
  return (
    <div>
      <Grid container spacing={2}>
        <Grid size={12}>
          {" "}
          <Typography fontSize={18} fontWeight={500} color="#1F2937">
            {" "}
            Company
          </Typography>
        </Grid>
        <Grid size={12}>
          <Box display={"grid"} width={"100%"}>
            <FormLabel>Company Name</FormLabel>
            <TextField
              size="small"
              id="outlined-basic"
              variant="outlined"
              value={formData?.name}
              onChange={(e: any) => handleChange("name", e?.target.value)}
            />
          </Box>
        </Grid>
        <Grid size={12}>
          <Box display={"grid"} width={"100%"}>
            <FormLabel>Floor</FormLabel>
            <TextField
              size="small"
              type="number"
              id="outlined-basic"
              variant="outlined"
              value={formData?.floor}
              onChange={(e: any) => handleChange("floor", e?.target.value)}
            />
          </Box>
        </Grid>
        <Grid size={12} display={"flex"} justifyContent={"end"}>
          {" "}
          <Box display={"display"}>
            <Button
              variant="contained"
              sx={{ mx: 1, bgcolor: "#1F2937" }}
              onClick={handleSubmit}
              size="small"
            >
              Save
            </Button>
            <Button
              variant="outlined"
              size="small"
              sx={{ color: "#1F2937", borderColor: "#1F2937" }}
              onClick={onClose}
            >
              Close
            </Button>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default CompanyForm;
